import { Stack } from '@mui/material';

import SimpleText from '../SimpleText';
import type { IdentifierProps } from './types';

export function Identifier({ bill }: Readonly<IdentifierProps>) {
  const { number } = bill;

  return (
    <Stack>
      <SimpleText text={number} />
    </Stack>
  );
}
